module.exports = __webpack_public_path__ + "img/@logo_cj@3x.2b2517ba.png";